import { createContext, useContext } from "react";
const defaultValue = {
    headerPortal: () => null,
    page: "",
};
export const PageHeaderContext = createContext(defaultValue);
export const PageHeaderProvider = PageHeaderContext.Provider;
export const PageHeaderConsumer = PageHeaderContext.Consumer;
export const usePageHeaderContext = () => {
    return useContext(PageHeaderContext);
};
